import React, { useEffect, useState } from "react";
import { makeStyles, Grid, Button } from "@material-ui/core/";
import TopPart from "../../Components/TopPart/TopPart";
import CardContent from "../../Components/CardContent/CardContent";
import Experience from "../../Components/Experience/Experience";
import PopUpCard from "../../Components/PopUpCard/PopUpCard";
import RoomData from "../../Components/ExtendCard/RoomData";
import Pagination from "../../Components/Pagination/Pagination";
function ExperiencePage() {
  const bg = require("../../Asset/Image/exp.jpg");
  const gb = require("../../Asset/Image/321.jpg");
  const useStyles = makeStyles((theme) => ({
    TopPartDiv: {
      padding: "0 6% 20px 6%",
      backgroundSize: "cover",
      height: "90vh",
      backgroundImage: "url(" + bg + ")",
    },

    DuLichGanNha: {
      position: "relative",
      top: "50vh",
      [theme.breakpoints.down("md")]: {
        top: "40vh",
        justifyContent: "center",
      },
    },

    CardContentDiv: {
      padding: "6% 6% 6% 6%",
      alignItems: "center",
      position: "relative",
    },

    ExperienceDiv: {
      margin: "0 auto",
      padding: "6% 6% 6% 6%",
      backgroundSize: "cover",
      backgroundImage: "url(" + gb + ")",
    },
  }));

  const classes = useStyles();
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(12);

  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  useEffect(() => {
    async function fetchPostList() {
      try {
        const requestUrl =
          "https://jsonplaceholder.typicode.com/photos?_start=0&_end=60";
        const response = await fetch(requestUrl);
        const responseJSON = await response.json();
        setPosts(responseJSON);
      } catch (error) {
        console.log("Error message: ", error.messeage);
      }
    }

    fetchPostList();
  }, []);

  function paginate(number) {
    setCurrentPage(number);
  }
  return (
    <div style={{ position: "relative" }}>
      <div className={classes.TopPartDiv}>
        <div className={classes.DuLichGanNha}>
          <TopPart />
        </div>
      </div>
      <div className={classes.CardContentDiv}>
        Có 60 chương trình trải nghiệm phù hợp - trang {currentPage}/5
        <Grid container justify="center" alignItem="center" xs={12}>
          {currentPosts.map((post, id) => {
            return (
              <Grid item container xs={12} sm={3} style={{ margin: "30px" }}>
                <PopUpCard
                  key={post.id}
                  mainPic={post.url}
                  cityName={post.cityName}
                  title={post.title}
                  rate={post.albumId}
                  price={post.price}
                />
              </Grid>
            );
          })}
        </Grid>
        <div style={{ marginTop: "50px", width: "100%", textAlign: "center" }}>
          <Pagination
            setScroll={650}
            paginate={paginate}
            postsPerPage={postPerPage}
            totalPosts={posts.length}
          />
        </div>
      </div>
    </div>
  );
}
export default ExperiencePage;
